/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TaskItemReferenceMeasurementInfoDto } from './TaskItemReferenceMeasurementInfoDto';
import {
    instanceOfTaskItemReferenceMeasurementInfoDto,
    TaskItemReferenceMeasurementInfoDtoFromJSON,
    TaskItemReferenceMeasurementInfoDtoFromJSONTyped,
    TaskItemReferenceMeasurementInfoDtoToJSON,
} from './TaskItemReferenceMeasurementInfoDto';

/**
 * @type ParameterCombinationDtoReferenceMeasurementInfo
 * 
 * @export
 */
export type ParameterCombinationDtoReferenceMeasurementInfo = TaskItemReferenceMeasurementInfoDto;


export function ParameterCombinationDtoReferenceMeasurementInfoFromJSON(json: any): ParameterCombinationDtoReferenceMeasurementInfo {
    return ParameterCombinationDtoReferenceMeasurementInfoFromJSONTyped(json, false);
}

export function ParameterCombinationDtoReferenceMeasurementInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterCombinationDtoReferenceMeasurementInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TaskItemReferenceMeasurementInfoDtoFromJSONTyped(json, true) };
    return  TaskItemReferenceMeasurementInfoDtoFromJSONTyped(json, true);
}

export function ParameterCombinationDtoReferenceMeasurementInfoToJSON(value?: ParameterCombinationDtoReferenceMeasurementInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTaskItemReferenceMeasurementInfoDto(value)) {
        return TaskItemReferenceMeasurementInfoDtoToJSON(value as TaskItemReferenceMeasurementInfoDto);
    }

    return {};
}

/**
 * Check if a given object implements the ParameterCombinationDtoReferenceMeasurementInfo interface.
 */
export function instanceOfParameterCombinationDtoReferenceMeasurementInfo(value: any): value is ParameterCombinationDtoReferenceMeasurementInfo {
    if (instanceOfTaskItemReferenceMeasurementInfoDto(value)) return true;
    return false;
}

